import React, { useEffect } from 'react'

import { getUrl } from '@js/common/getUrlByDomain'
import { isHouseRelatedType } from '@js/common/utils'

import CTA from '@f/elements/CTA'

import OutfittersContent from './partials/OutfittersContent'

const RequestSuccess = props => {
  useEffect(() => {
    props.actions.completeProgressBar()
  }, [])

  let heading = 'Ihre Anfrage wurde versandt'
  let subHeading
  let mariaChatMessage
  let ctaButton = null
  const { gender, last_name } = props.data.user

  if (isHouseRelatedType(props.requestType)) {
    subHeading = 'Sie finden eine Bestätigungs-Email in Ihrem Postfach.'
    mariaChatMessage = (
      <>
        {`${
          gender === 'm' ? 'Herr' : 'Frau'
        } ${last_name}, entdecken Sie jetzt vergleichbare Häuser zu Ihrer Anfrage.`}
      </>
    )

    ctaButton = (
      <CTA
        tag='a'
        href={`${getUrl('houseList')()}`}
        type='block-primary'
        className='[ f-m-h-auto f-m-t-020 ] is-block:s'
        data-sel='btn-cta'>
        Ähnliche Häuser anzeigen
      </CTA>
    )
  } else {
    subHeading = 'Sie finden eine Bestätigungs-Email in Ihrem Postfach.'
  }

  if (props.data.selected_instances && props.data.selected_instances.vendors) {
    if (props.data.prequal) {
      subHeading =
        'Wir melden uns im nächsten Schritt für eine kurze telefonische Abstimmung, um Ihnen die optimalen Informationen zusammenstellen zu können. Dieser Service ist für Sie kostenlos und unverbindlich.'
    } else {
      subHeading =
        'Die angefragten Anbieter werden Ihnen in Kürze weitere Informationen zukommen lassen.'
    }
  }

  let modalContent
  props.actions.update_wtValue({ value: 'success-outfitters' })
  modalContent = (
    <OutfittersContent
      heading={heading}
      subHeading={subHeading}
      mariaChatMessage={mariaChatMessage}
      {...props}
    />
  )

  return (
    <>
      {modalContent}
      {ctaButton}
    </>
  )
}

export default RequestSuccess
